import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const sendCommunicationRequestApi = createAsyncThunk(
    "order/communication",
    async (reqBody:any)=> {
        const { axiosPost } = useCustomAxios();
        try {
            // const response = await axiosGet(`${API_ENDPOINTS.getSecurityGroup}`);
            const response = await axiosPost(`${API_ENDPOINTS.createCommunication}`,reqBody);
            return { data: response.data, status: response.status };
          } catch (error: any) {
            return {
              error: error.response.data.message,
              status: error.response.status,
            };
          }
    }
)

